import React from 'react';

import classes from './styles.module.scss';

const LoadingIndicatorBar = () => {
    return (
        <div className={classes.root}>
            <div className={classes.bar} />
        </div>
    );
};

LoadingIndicatorBar.propTypes = {};

export default LoadingIndicatorBar;
